// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemsSection_container__1zQyy","labelButton":"ItemsSection_labelButton___qjlE"};